import React, { useContext } from 'react';
import { Redirect } from "react-router";
import { NavLink } from 'react-router-dom';

import RestorePasswordForm from '../components/Form/RestorePasswordForm';
import { AuthContext } from "../context/auth/authContext";

// Assets
import HeroBg from '../i/bg_section_5.jpg';

export const RestorePassword = () => {
	const { currentUser } = useContext(AuthContext);

	if (currentUser) {
		return <Redirect to="/my-streams" />
	}

	return (
		<div>
			{!currentUser ? (
				<React.Fragment>
					<section className="section hero_v2_mod center_level_mod bottom_decor_mod">
						<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${HeroBg})` }} />
					</section>
					<section className="section">
						<div className="section_in">
							<div className="section_heading center_level_mod offset_mod">
								<h2 className="section_title accent_mod hero_mod">Restore Password</h2>
								<div className="section_descr accent_mod">
									<p>Please enter your email which you used when registering</p>
								</div>
							</div>
							<div className="form_w size_mod">
								<RestorePasswordForm />
							</div>
						</div>
					</section>
				</React.Fragment>
			) : null}
		</div>
	);
}
export default RestorePassword;